export default __webpack_public_path__ + "d20cb3f565f59a4a676cad36906644bc.svg";